import { Link } from "react-router-dom";

export const topNews2 = [{
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202306/modi_shah_nadda-sixteen_nine.jpg?size=948:533",
        category: "मध्य प्रदेश",
        title: "बीजेपी संगठन महामंत्री हितानंद शर्मा की अहम बैठक, चुनावी तैयारियों पर चर्चा",
        author: "Sanjay Gupta",
        date: "Jan 03, 2026 19:36 IST",
        readTime: "2 Min read",
        fullNews: `दिल्ली और इंदौर के बीच बीजेपी संगठन स्तर पर गतिविधियां तेज हो गई हैं।
बैठक में आगामी चुनाव और संगठनात्मक मजबूती पर चर्चा की गई।
वरिष्ठ नेताओं के साथ लगातार बैठकों का दौर जारी है।`,
        link: "/mp",
    },
    {
        image: "https://images.moneycontrol.com/static-mcnews/2024/05/20240502115944_200241-yzevpqohut-1713861432-1-770x404.jpeg?impolicy=website&width=770&height=431",
        category: "राजनीति",
        title: "2026 चुनाव से पहले बीजेपी की रणनीति, संगठन में बदलाव संभव",
        author: "Political Desk",
        date: "Jan 03, 2026 18:10 IST",
        readTime: "3 Min read",
        fullNews: `2026 विधानसभा चुनाव से पहले बीजेपी संगठन में बदलाव की चर्चा तेज है।
सूत्रों के अनुसार कई जिलों में नई जिम्मेदारियां तय की जा सकती हैं।`,
    },
];

export const topNews = [{
        image: "https://th-i.thgim.com/public/incoming/xy2ju0/article67931771.ece/alternates/FREE_1200/PTI03_09_2024_000073B.jpg",
        category: "मध्य प्रदेश",
        title: "मध्य प्रदेश की राजनीति में नए समीकरण, कई सीटों पर बदलाव की संभावना",
        author: "News Desk",
        date: "Jan 03, 2026 17:45 IST",
        readTime: "2 Min read",
        fullNews: `मध्य प्रदेश की राजनीति में नए समीकरण सामने आ रहे हैं।
कुछ क्षेत्रों में नए चेहरों को मौका मिलने की चर्चा है।`,
    },
    {
        image: "https://ichef.bbci.co.uk/ace/ws/640/cpsprodpb/1747/live/d9bf1190-c721-11ee-baf9-679cc8378c25.jpg.webp",
        category: "मध्य प्रदेश",
        title: "चुनावी हलचल तेज, कई सीटों पर प्रत्याशी बदलने की अटकलें",
        author: "News Desk",
        date: "Jan 03, 2026 17:45 IST",
        readTime: "2 Min read",
        fullNews: `राज्य में चुनावी हलचल तेज हो गई है।
पार्टियां कई सीटों पर नए नामों पर विचार कर रही हैं।`,
    },
    {
        image: "https://staticimg.amarujala.com/assets/images/2025/12/28/lsa-mahanathashaka-o-pa-saha-karanal-ka-mathhabna-ma-madaya-paratanathhaya-sa-makhatab-hata-hae_d2b3fb467b800e33c38c09c299f22c08.jpeg?w=414&dpr=1.0&q=80",
        category: "मध्य प्रदेश",
        title: "राज्य की राजनीति में हलचल, रणनीति पर मंथन जारी",
        author: "News Desk",
        date: "Jan 03, 2026 17:45 IST",
        readTime: "2 Min read",
        fullNews: `राजनीतिक दल रणनीति को लेकर लगातार बैठकें कर रहे हैं।
आगामी चुनावों को लेकर सक्रियता बढ़ी है।`,
    },
    {
        image: "https://www.jagranimages.com/images/newimg/03092025/03_09_2025-bjp_meeting_24034886.webp",
        category: "राजनीति",
        title: "चुनाव से पहले संगठनात्मक बदलाव, बीजेपी में मंथन",
        author: "Political Desk",
        date: "Jan 03, 2026 18:10 IST",
        readTime: "3 Min read",
        fullNews: `चुनाव से पहले संगठनात्मक स्तर पर बदलाव की संभावना जताई जा रही है।
पार्टी सूत्रों के अनुसार जल्द फैसले हो सकते हैं।`,
    },
    {
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202407/66a5cbe278c52-bjp-cms-meet-284105115-16x9.png?size=948:533",
        category: "राजनीति",
        title: "बीजेपी में संगठन को मजबूत करने पर जोर",
        author: "Political Desk",
        date: "Jan 03, 2026 18:10 IST",
        readTime: "3 Min read",
        fullNews: `पार्टी नेतृत्व संगठन को मजबूत करने पर फोकस कर रहा है।
जिलों में बैठकें और समीक्षा जारी है।`,
    },
    {
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202201/bjp_1-sixteen_nine-sixteen_nine.jpg",
        category: "राजनीति",
        title: "आगामी चुनाव को लेकर पार्टी रणनीति तैयार",
        author: "Political Desk",
        date: "Jan 03, 2026 18:10 IST",
        readTime: "3 Min read",
        fullNews: `आगामी चुनावों को ध्यान में रखते हुए रणनीति बनाई जा रही है।
पार्टी स्तर पर बैठकों का दौर जारी है।`,
    },
];

export const mpNews = [{
        image: "https://www.jagranimages.com/images/newimg/09052024/09_05_2024-voters_women_23714545.webp",
        category: "मध्य प्रदेश",
        title: "इंदौर में शांतिपूर्ण मतदान, प्रशासन संतुष्ट",
        author: "Amit Patel",
        date: "Jan 02, 2026",
        readTime: "2 Min read",
        fullNews: `इंदौर में मतदान शांतिपूर्ण तरीके से संपन्न हुआ।
प्रशासन ने सुरक्षा व्यवस्था को लेकर संतोष जताया।`,
    },
    {
        image: "https://imgs.etvbharat.com/etvbharat/prod-images/04-03-2025/1200-675-23665940-thumbnail-16x9-mohan.jpg",
        category: "मध्य प्रदेश",
        title: "भोपाल में कैबिनेट बैठक, नई योजनाओं पर चर्चा",
        author: "City Desk",
        date: "Jan 02, 2026",
        readTime: "3 Min read",
        fullNews: `भोपाल में हुई बैठक में विकास योजनाओं पर चर्चा की गई।
सरकार ने तेजी से काम करने के संकेत दिए हैं।`,
    },
    {
        image: "https://img-cdn.publive.online/fit-in/640x430/filters:format(webp)/bansal-news/media/media_files/2025/12/18/up-school-timing-change-2025-12-18-10-13-07.jpg",
        category: "मध्य प्रदेश",
        title: "ग्वालियर-चंबल में ठंड बढ़ी, स्कूल समय बदला",
        author: "Local Reporter",
        date: "Jan 01, 2026",
        readTime: "2 Min read",
        fullNews: `तापमान में गिरावट के चलते ठंड बढ़ गई है।
प्रशासन ने स्कूलों के समय में बदलाव किया है।`,
    },
];

export const videonews = [{
        image: "https://img.naidunia.com/naidunia/ndnimg/02092024/02_09_2024-mohan_cabinet_3_sep_202492_22258.webp",
        category: "मध्य प्रदेश",
        title: "भोपाल कैबिनेट बैठक की अहम बातें",
        author: "City Desk",
        date: "Jan 02, 2026",
        readTime: "3 Min read",
        fullNews: `कैबिनेट बैठक में कई अहम फैसलों पर चर्चा हुई।
सरकार ने विकास पर जोर दिया है।`,
        videoUrl: "https://youtu.be/CB6sFPV8PdA?si=h6IPVjablK6ZxDUA",
    },
    {
        image: "https://feeds.abplive.com/onecms/images/uploaded-images/2025/12/11/8cb6fe84cca30a2796dbdcbf4b0ce3c41765416329666584_original.jpg?impolicy=abp_cdn&imwidth=1200",
        category: "मध्य प्रदेश",
        title: "ठंड बढ़ने से बदला स्कूलों का समय",
        author: "Local Reporter",
        date: "Jan 01, 2026",
        readTime: "2 Min read",
        fullNews: `ठंड के कारण स्कूलों के समय में बदलाव किया गया है।
बच्चों की सुरक्षा को ध्यान में रखा गया है।`,
        videoUrl: "https://youtu.be/L7fIF53G_P4?si=ZvRBqkxfTg_9OLnH",
    },
];

export const webStories = [{
        id: 1,
        image: "https://www.livehindustan.com/lh-img/smart/img/2025/06/13/1200x900/uttarakhand_rain_1744259893841_1749778376405.jpg",
        title: "MP में बदला मौसम",
        category: "मौसम",
    },
    {
        id: 2,
        image: "https://www.livehindustan.com/lh-img/smart/img/2025/02/13/1000x563/board_exam_3_1738383392152_1739457791917.jpg",
        title: "CBSE बोर्ड परीक्षा अपडेट",
        category: "शिक्षा",
    },
    {
        id: 3,
        image: "https://cf-img-a-in.tosshub.com/lingo/nwtak/images/story/202511/6913fdbc6ae21-while-colabas-voter-turnout-was-low--it-still-showed-a-slight-improvement-compared-to-kalyan-west-201209912-16x9.jpeg?size=768:432&q=50",
        title: "इंदौर मतदान रिकॉर्ड",
        category: "राजनीति",
    },
    {
        id: 4,
        image: "https://qph.cf2.quoracdn.net/main-qimg-445c48edb0461eb1d966801f6da66b2d-lq",
        title: "सोशल मीडिया पर वायरल वीडियो",
        category: "वायरल",
    },
];